<nb-card class="dialog-card turma-detalhes-dialog">
  <nb-card-header>
    <div class="header-detalhes">
      <div class="titulo-bloco">
        <span class="titulo-texto">{{ turmaCabecalho.nome || 'Turma' }}</span>
        <span class="status-badge" [class.status-badge--ativa]="isAtiva()" [class.status-badge--inativa]="!isAtiva()">
          {{ isAtiva() ? 'Ativa' : 'Inativa' }}
        </span>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div
      class="foto-popup-overlay"
      *ngIf="fotoPopupAberta"
      role="dialog"
      aria-modal="true"
      aria-label="Foto do catequizando"
      (click)="fecharFotoPopup()"
    >
      <div class="foto-popup-panel" (click)="$event.stopPropagation()">
        <div class="foto-popup-header">
          <span class="foto-popup-titulo">{{ fotoPopupTitulo }}</span>
          <button
            nbButton
            ghost
            size="tiny"
            type="button"
            class="foto-popup-fechar"
            aria-label="Fechar"
            (click)="fecharFotoPopup()"
          >
            <nb-icon pack="eva" icon="close-outline"></nb-icon>
          </button>
        </div>
        <div class="foto-popup-body">
          <img
            *ngIf="fotoPopupUrl"
            class="foto-popup-imagem"
            [src]="fotoPopupUrl"
            alt="Foto do catequizando"
            (error)="onFotoPopupErro()"
          />
        </div>
      </div>
    </div>

    <div class="loading-wrap" *ngIf="carregando">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando…</span>
    </div>

    <ng-container *ngIf="!carregando">
      <section class="secao">
        <h4 class="secao-titulo">Catequizandos matriculados</h4>
        <p class="secao-erro" *ngIf="erroAlunos">{{ erroAlunos }}</p>
        <div class="table-wrap" *ngIf="matriculas.length && !erroAlunos">
          <table class="detalhes-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF</th>
                <th>Telefone</th>
                <th class="col-acoes-detalhes">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let m of matriculas; trackBy: trackByMatricula">
                <td data-label="Nome">
                  <a
                    *ngIf="podeLinkCadastroPessoa() && m.pessoaId?.trim(); else nomeMatriculaTexto"
                    class="link-cadastro-pessoa"
                    href="#"
                    (click)="abrirCadastroPessoa(m, $event)"
                    title="Abrir cadastro da pessoa"
                  >
                    {{ m.pessoaNome || '—' }}
                  </a>
                  <ng-template #nomeMatriculaTexto>{{ m.pessoaNome || '—' }}</ng-template>
                </td>
                <td data-label="CPF">{{ m.pessoaCpf?.trim() ? m.pessoaCpf : '—' }}</td>
                <td data-label="Telefone">{{ m.pessoaTelefone?.trim() ? m.pessoaTelefone : '—' }}</td>
                <td class="col-acoes-detalhes" data-label="Ações">
                  <div
                    class="turma-acoes-btns"
                    role="group"
                    [attr.aria-label]="'Ações: ' + (m.pessoaNome || '')"
                  >
                    <button
                      type="button"
                      nbButton
                      size="small"
                      [appearance]="temFoto(m) ? 'filled' : 'outline'"
                      [status]="temFoto(m) ? 'success' : 'basic'"
                      [disabled]="!temFoto(m)"
                      class="turma-acao-icon"
                      (click)="verFoto(m, $event)"
                      title="Ver foto"
                      aria-label="Ver foto do catequizando"
                    >
                      <nb-icon pack="eva" icon="image-outline"></nb-icon>
                    </button>
                    <button
                      type="button"
                      nbButton
                      size="small"
                      appearance="outline"
                      status="warning"
                      class="turma-acao-icon"
                      (click)="transferir(m, $event)"
                      title="Transferir"
                      aria-label="Transferir para outra turma"
                    >
                      <nb-icon pack="eva" icon="swap-outline"></nb-icon>
                    </button>
                    <button
                      type="button"
                      nbButton
                      size="small"
                      appearance="outline"
                      status="danger"
                      class="turma-acao-icon"
                      (click)="desmatricular(m, $event)"
                      title="Desmatricular"
                      aria-label="Desmatricular"
                    >
                      <nb-icon pack="eva" icon="person-remove-outline"></nb-icon>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="secao-vazio" *ngIf="!matriculas.length && !erroAlunos">Nenhum catequizando nesta turma.</p>
      </section>

      <section class="secao">
        <h4 class="secao-titulo">Usuários com acesso à turma</h4>
        <p class="secao-erro" *ngIf="erroUsuarios">{{ erroUsuarios }}</p>
        <div class="table-wrap" *ngIf="usuarios.length && !erroUsuarios">
          <table class="detalhes-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Login</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of usuarios; trackBy: trackByUsuario">
                <td data-label="Nome">{{ u.nome || '—' }}</td>
                <td data-label="Login">{{ (u.login?.trim()) ? u.login : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="secao-vazio" *ngIf="!usuarios.length && !erroUsuarios">Nenhum usuário vinculado a esta turma.</p>
      </section>
    </ng-container>
  </nb-card-body>
  <nb-card-footer class="footer-actions">
    <button nbButton status="basic" type="button" size="medium" (click)="fechar()">Fechar</button>
    <button
      nbButton
      status="primary"
      type="button"
      size="medium"
      appearance="outline"
      [disabled]="!turmaCabecalho.id?.trim()"
      (click)="abrirEditar()"
    >
      <nb-icon pack="eva" icon="edit-outline"></nb-icon>
      <span>Editar turma</span>
    </button>
  </nb-card-footer>
</nb-card>
